import PostalCodeAutocomplete from "../../../common/utils/PostalCodeAutocomplete";
import CartRecap from "../../utils/checkout/CartRecap";

export default class Infos {

    constructor() {
        this.cart_recap = new CartRecap();
        this.postalCodeAutocomplete = new PostalCodeAutocomplete();
        this.customer_is_under_18 = false;
        this.compute_age();
        this.initValidation();
        this.bindEvents();
    }


    bindEvents() {
        var self = this;

        // Disable HTML5 validation on birth date field more aggressively
        $('input[name="customer[birth_date]"]').on("invalid", function(e) {
            e.preventDefault();
            return false;
        });

        // Also prevent the default validation on input event
        $('input[name="customer[birth_date]"]').on("input", function(e) {
            // Remove any HTML5 validation attributes that might be added dynamically
            $(this).removeAttr('max').removeAttr('min');
        });

        $('input[name="customer[birth_date]"]').on("change", function() {
            self.compute_age(); 
            self.initValidation();
        });

        $('input[name="has_disability"]').on("change", function() {
            self.check_disability();
            self.initValidation();
        });
    }

    check_disability() {
        if($('input[name="has_disability"]:checked').val() == "true" )
            $("#disability_part").removeClass("d-none")
        else 
            $("#disability_part").addClass("d-none");
    }

    compute_age() {
        if($('input[name="customer[birth_date]"]').val() == "") {
            this.customer_is_under_18 = false;
            $("#age_warning_message").addClass("d-none");
            return;
        }
        //Compute age from birth date
        var today = new Date();
        var birthDate = new Date($('input[name="customer[birth_date]"]').val());
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        
        if (age < 18) {
            this.customer_is_under_18 = true;
        }
        else {
            this.customer_is_under_18 = false;
        }

        // Toggle housing part visibility
        if (this.customer_is_under_18) {
            $("#is_hosted_part").addClass("d-none");
        } else {
            $("#is_hosted_part").removeClass("d-none");
        }

        // Check if age is between 16 and 17 years old
        if (age >= 16 && age < 17) {
            $("#age_warning_message").removeClass("d-none");
        } else {
            $("#age_warning_message").addClass("d-none");
        }

    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.cart_recap.onDestroy();
        this.postalCodeAutocomplete.onDestroy();
    }

    initValidation() {
        const base_rules = {
            "customer[first_name]": {
                required: true
            },
            "customer[last_name]": {
                required: true
            },
            "customer[email]": {
                required: true,
                email_validation: true
            },
            "customer[phone]": {
                required: true,
                phone_number_fr: true
            },
            "customer[birth_date]": {
                required: true,
                min_age_validation: true
            },
            "customer[birth_place]": {
                required: true
            },
            "customer[password]": {
                password_validation: true
            },
            "customer[address_line1]": {
                required: true
            },
            "customer[has_highway_code]": {
                required: true
            },
            "customer[is_hosted]": {
                required: true
            },
            "customer[postal_code]": {
                required: true,
                remote: {
                    url: $('#customer_postal_code').data('urlvalidate'),
                    data: {
                        postal_code: function() {
                            return $('#customer_address_postal_code').val();
                        }
                    }
                }
            },
            "customer[neph_code]": {
                neph: true
            }
        };

        let rules = Object.assign({}, base_rules);

        if(this.customer_is_under_18) {
            $("#responsible_part").removeClass("d-none");
            rules["customer[responsible_first_name]"] = {
                required: true
            };

            rules["customer[responsible_last_name]"] = {
                required: true
            };

            rules["customer[responsible_phone_number]"] = {
                required: true,
                phone_number_fr: true
            };

            rules["customer[responsible_email]"] = {
                required: true,
                email_validation: true,
                responsible_email_different: "#customer_email"
            };
        }
        else {
            $("#responsible_part").addClass("d-none");
            $('input[name="customer[responsible_first_name]"]').removeAttr('required');
            $('input[name="customer[responsible_last_name]"]').removeAttr('required');
            $('input[name="customer[responsible_phone_number]"]').removeAttr('required');
            $('input[name="customer[responsible_email]"]').removeAttr('required');
        }

        if($('input[name="has_disability"]:checked').val() == "true" ) {
            rules["customer[disability_type]"] = {
                required: true
            };
        }

        application.setTemplateValidation(rules, '#infos_form')
    }
}